/* eslint-disable @typescript-eslint/no-require-imports */
import { useRouter } from 'expo-router';
import React, { PropsWithChildren, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { isWeb } from 'shared/constants/platform';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { AuthContext, AuthContextProps } from 'shared/providers/auth';

function SubTabErrorBoundary({ children }: PropsWithChildren) {
  const router = useRouter();
  const { handleLogout } = useContext<AuthContextProps>(AuthContext);
  const { t: translatedText } = useTranslation('patterns', {
    keyPrefix: 'errorBoundaries',
  });
  const errorScreenProps = {
    screenType: ErrorScreenType.Error,
    messageHeadline: translatedText('title'),
    messageBody: translatedText('message'),
    primaryButton: {
      title: translatedText('primaryButtonDone'),
      onPress: () => router.replace('/'),
    },
    secondaryButton: {
      title: translatedText('secondaryButtonLogout'),
      onPress: () => {
        void handleLogout();
      },
    },
  };

  if (!isWeb) {
    const { ErrorBoundary: SentryErrorBoundary } =
      require('@sentry/react-native') as typeof import('@sentry/react-native');

    return (
      <SentryErrorBoundary fallback={<ErrorScreen {...errorScreenProps} />}>
        {children}
      </SentryErrorBoundary>
    );
  }

  const { ErrorBoundary: SentryErrorBoundary } =
    require('@sentry/react') as typeof import('@sentry/react');

  return (
    <SentryErrorBoundary fallback={<ErrorScreen {...errorScreenProps} />}>
      {children}
    </SentryErrorBoundary>
  );
}

export default SubTabErrorBoundary;
